import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Session lives in a secure HTTP-only cookie - validate via /auth/me
    const initAuth = async () => {
      // Purge legacy localStorage tokens from the old auth scheme
      localStorage.removeItem('wahr_token');
      localStorage.removeItem('wahr_user');
      try {
        const userData = await authAPI.getMe();
        setUser(userData);
      } catch (error) {
        setUser(null);
      }
      setLoading(false);
    };
    
    initAuth();
  }, []);

  const login = async (email, password) => {
    try {
      const response = await authAPI.login(email, password);
      
      setUser({
        id: response.id,
        email: response.email,
        name: response.name,
        role: response.role
      });
      
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.detail || 'Anmeldung fehlgeschlagen';
      return { success: false, error: typeof message === 'string' ? message : 'Anmeldung fehlgeschlagen' };
    }
  };

  const register = async (name, email, password) => {
    try {
      const response = await authAPI.register(name, email, password);
      
      setUser({
        id: response.id,
        email: response.email,
        name: response.name,
        role: response.role
      });
      
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.detail || 'Registrierung fehlgeschlagen';
      return { success: false, error: typeof message === 'string' ? message : 'Registrierung fehlgeschlagen' };
    }
  };

  const logout = async () => {
    try {
      await authAPI.logout();
    } catch (error) {
      // Cookie clearing failed server-side - still clear local state
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
